<template>
  <div class="callback-page">
    <div class="callback-container" v-if="!showModal">
      <div class="callback-card">
        <div class="callback-header">
          <h2>Logging you in...</h2>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import apiClient from '@/http'; // Adjust the import path as needed
import {BModal, BForm, BFormGroup, BFormInput, BButton} from 'bootstrap-vue';

export default {
  name: 'Callback',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton
  },
  data() {
    return {
      showModal: false,
      orgName: '',
      accessToken: '',
      provider: ''
    };
  },
  methods: {
    async handleCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      let provider = null;
      let orgCode = null;

      if (state) {
        const parsedState = JSON.parse(state);
        provider = parsedState.provider;
        orgCode = parsedState.orgCode;
      }
      const caller = 'app';
      if (code && provider && orgCode) {
        try {
          const response = await apiClient.get(`/auth/exchange-token`, {
            params: {
              code,
              provider,
              orgCode,
              caller
            }
          });

          const tokenData = response.data;
          window.location.href = 'cloudam://callback?token=' + tokenData.access_token + '&org=' + orgCode;
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.accessToken = error.response.data.access_token;
            this.provider = error.response.data.provider;
            this.showModal = true;
          } else {
            console.error('Error exchanging code for token:', error);
          }
        }
      } else {
        console.error('Missing code or provider');
      }
    },
  },
  mounted() {
    this.handleCallback();
  }
};
</script>

<style scoped>
.callback-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.callback-container {
  width: 300px;
}

.callback-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.callback-header {
  text-align: center;
}
</style>
